var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32091 0.0135963C9.27267 0.132568 9.94783 1.00062 9.82892 1.95243L9.42158 5.21066H14.0261L14.4872 1.52157C14.6062 0.569759 15.4743 -0.105387 16.426 0.0135963C17.3778 0.132568 18.053 1.00062 17.9341 1.95243L17.5267 5.21066H20.263C21.2222 5.21066 21.9998 5.98825 21.9998 6.94747C21.9998 7.90669 21.2222 8.68429 20.263 8.68429H17.0925L16.5136 13.3157H19.6841C20.6433 13.3157 21.4209 14.0934 21.4209 15.0526C21.4209 16.0119 20.6433 16.7894 19.6841 16.7894H16.0794L15.6183 20.4785C15.4993 21.4303 14.6312 22.1054 13.6794 21.9864C12.7277 21.8675 12.0525 20.9994 12.1714 20.0476L12.5788 16.7894H7.97426L7.51313 20.4785C7.39416 21.4303 6.52612 22.1054 5.57431 21.9864C4.6225 21.8675 3.94735 20.9994 4.06633 20.0476L4.4736 16.7894H2.31592C1.3567 16.7894 0.579102 16.0119 0.579102 15.0526C0.579102 14.0934 1.3567 13.3157 2.31592 13.3157H4.9078L5.48674 8.68429H2.89486C1.93564 8.68429 1.15804 7.90669 1.15804 6.94747C1.15804 5.98825 1.93564 5.21066 2.89486 5.21066H5.92094L6.38208 1.52157C6.50105 0.569759 7.3691 -0.105387 8.32091 0.0135963ZM13.013 13.3157L13.5919 8.68429H8.98737L8.40847 13.3157H13.013Z",
    fill: "#A9A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHash);
export default __webpack_public_path__ + "static/media/hash.54e05e80be96670676fb38d470e914c5.svg";
export { ForwardRef as ReactComponent };